import { BlogIndexPage } from "@/components/blog/blog-pages";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/operator/blog/")({
  component: () => (
    <BlogIndexPage portal="operator" basePath="/operator/blog" />
  ),
});
